import { cn } from "@/lib/utils";
import React from "react";

export function PageTitle({
  title,
  className,
  logoComponent,
}: {
  title: string;
  className?: string;
  logoComponent?: React.ReactNode;
}) {
  return (
    <div className={cn("w-full px-6 pt-6 pb-4", className)}>
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold text-foreground">{title}</h1>
        {logoComponent}
      </div>
    </div>
  );
}
